import { render, staticRenderFns } from "./Scta.vue?vue&type=template&id=7f28e4b2&scoped=true&"
import script from "./Scta.vue?vue&type=script&lang=js&"
export * from "./Scta.vue?vue&type=script&lang=js&"
import style0 from "./Scta.vue?vue&type=style&index=0&id=7f28e4b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f28e4b2",
  null
  
)

export default component.exports